export enum CompanyLinks {
  AboutUs = "https://onlygood.ai/about-us/",
  Careers = "https://wellfound.com/company/onlygood",
  Blog = "https://onlygood.ai/blogs-2/",
  ContactUs = "https://onlygood.ai/contact-us-new/",
}
